import { render, staticRenderFns } from "./journey2.vue?vue&type=template&id=a083a31a&"
import script from "./journey2.vue?vue&type=script&lang=js&"
export * from "./journey2.vue?vue&type=script&lang=js&"
import style0 from "./journey2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports